import groq from 'groq';

export const navigationLabelsQuery = groq`
  *[_type == "navigationLabels"][0] {
    home,
    companies,
    aboutUs,
    ourValues,
    objective,
    motion,
    news,
    ourClients,
    contactUs,
    termsAndConditions
  }
`;
